import Task from "../task";
import {SessionCustomField} from "../../../gd-model/custom-field/gd-custom-field";
import {ValidationAction} from "../../../modules/validations/@const";

// const debug = "TaskSave"
const debug = false

// this is a list of fields that univeral update supports!
const universalUpdateFields = new Set([

    'crmAccountId',
    'crmContactIds',
    'storyPoints',
    'priority',
    'deadline',
    'startDate',
    'endDate',
    'scheduleDate',
    'scheduleStatus',
    'taskTypeId',
    'actionRequiredUserId',
    'assignedToUserId',
    'statusId',
    'progress',
    'estimate',
    'tags',

    // 'customFieldsData' - nope... indiviaudl'no update idet

]);

export default class TaskSave {

    public task     : Task

    constructor(task:Task) {
        this.task = task;

        if (this.task.id)   this.update();
        else                this.createNew();
    }

    update() {

        debug && console.log(debug, "Updated fields=", this.task.updatedFields)

        // update
        // send request to task/XXX/update and pass all changed fields

        // a te kto ne podderzivaetusa poka nichego ne delat' ili uzt staroe
        // a luch'she govorit' mne i ya dobavly v universal update !


        // // patch ?
        // if (this.task.updatedFields.has('_startDate')) this.task.updatedFields.add('startDate')
        // if (this.task.updatedFields.has('_endDate')) this.task.updatedFields.add('endDate')

        // task.updatedFields
        // vzyat' te fields kot. supported by universal update only'
        const updateParameters  = _.intersection([...this.task.updatedFields], [...universalUpdateFields]);
        const updateData : any  = updateParameters ? _.pick(this.task, updateParameters) : {};

        // !!! if udpateDate budet imet' properties to nado properties toJSON  tut budet sdelat'

        // Patch dates

        if (_.has(updateData, 'startDate') && !_.has(updateData,'endDate')) {
            // @ts-ignore
            updateData['endDate'] = this.task.endDate
        }

        if (_.has(updateData, 'endDate') && !_.has(updateData,'startDate')) {
            // @ts-ignore
            updateData['startDate'] = this.task.startDate
        }

        if (_.has(updateData, 'tags') && !_.has(updateData,'tags')) {
            // @ts-ignore
            updateData['tags'] = this.task.tags
        }
        //
        // // Update status dependency check
        // if (_.has(updateData, 'statusId')) {
        //     gd.modules.validations.updateRequestPayloadOnTaskStatusChange(updateData)
        // }
        // // Update scheduleDate dependency check
        // if (_.has(updateData, 'scheduleDate') && !(_.has(updateData, 'startDate') || _.has(updateData, 'startDate'))) {
        //     console.log( "        if (_.has(updateData, 'scheduleDate') && !(_.has(updateData, 'startDate') || _.has(updateData, 'startDate'))) {"   )
        //     gd.modules.validations.updateRequestPayloadOnScheduleChange(updateData)
        // }
        // // Update start/end date dependency check
        // if (_.has(updateData, 'startDate') || _.has(updateData, 'startDate')) {
        //     gd.modules.validations.updateRequestPayloadOnTaskStartEndDateChange(updateData)
        // }

        // custom fields start
        this.task.updatedFields.forEach((fieldName) => {
            if (fieldName.substring(0,3)==='cf-') {
                const customFieldId : ID = fieldName.substring(3)
                const customField   : SessionCustomField | undefined = gd.session.customFields.get(customFieldId)
                if (customField) {
                    // @ts-ignore
                    updateData["cf-"+customField.id] = customField.updatePayload(this.task[customField.id])
                }
            }
        });
        // Custom fields end


        // Save changes
        if (!_.isEmpty(updateData)) {
            debug && console.log(debug, " Save changes" , updateData)
            gd.api.Task.update(this.task.id,updateData)
        }


        // We saved means we need reset !
        this.task.updatedFields.clear()


    }

    createNew() {
        // create new
        /*not implemented yet*/
    }
}
